// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { withRouter } from 'react-router-dom'
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import qs from 'query-string'

import {
  TabbedView,
  // EmployerWhatsAppMessages,
  EmployerWhatsAppEditor,
  EmployerAccountSwitcher,
  EmployerCommunications,
  EmployerGroupCommunications,
  SvgIcon,
  ErrorBoundary,
  NavLink
} from '../../components'

import { AccountContext } from '../../context'


const QUERY_EMPLOYER_IDENTITY = gql`
  query($id: ID!) {
    employer(id: $id) {
      id
      identity {
        id
      }
    }
  }
`

const getTabFromQueryString = (queryString) => {
  let queryParams = qs.parse(queryString)

  let state = Object.assign(
    {},
    ...Object.keys(queryParams).map(key => (
      key === 'tab'
        ? { currentTab: parseInt(queryParams[key], 10) }
        : null
    ))
  )
  return state
}


class EmployerWhatsApp extends PureComponent {
  static propTypes = {
    fromAddr: PropTypes.string,
    toAddr: PropTypes.string,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]),
    noStatusFilter: PropTypes.bool
  }

  static defaultProps = {
    title: <div className='slds-grid' style={{ alignItems: 'center'}}>
        <Icon icon={faWhatsapp} size='3x' />
        <div className='slds-m-left_medium u-font-size-x-large u-text-caps'>
          WhatsApp
        </div>
      </div>
  }

  state = {
    currentTab: 0,
    selectedAccountId: this.props.match.params.employerGroupId
  }

  componentDidMount() {
    if (this.props.location.search.length === 0) {
      this.setQueryString()
    } else {
      this.setState(getTabFromQueryString(this.props.location.search))
    }
  }

  setQueryString = () => {
    this.props.history.push({
      search: qs.stringify({
        tab: this.state.currentTab
      })
    })
  }

  changeSelectedAccountId = (e) => (
    this.setState({ selectedAccountId: e.target.value })
  )

  displayAssociatedContent = (currentTab, isEmployerGroupAccount, switchAccount) => {
    const MESSAGES = 0
    const EDITOR = 1


    if (currentTab === MESSAGES) {
      const currentPath = this.props.location.pathname
      return (
        <React.Fragment>
          <div className='slds-col slds-size_10-of-12 slds-scrollable_x slds-border_top'>
            {isEmployerGroupAccount
              ? <EmployerGroupCommunications
                  employerGroupId={this.props.match.params.employerGroupId}
                  communicationType='WhatsApp'
                  urlPath={currentPath}
                  title={null}
                  lockOnCommunicationType={true}
                />
              : <Query query={QUERY_EMPLOYER_IDENTITY} variables={{ id: this.props.match.params.employerId }}>
                  {({ loading, error, data }) => {
                    if (loading || error) {
                      return null
                    }
                    return (
                      <ErrorBoundary
                        errorText={
                          <div>
                            Unfortunately this listing page seems broken.
                            <NavLink to='/dashboard' className='slds-p-left_x-small'>
                              Go to dashboard page
                            </NavLink>
                          </div>
                        }>
                        <EmployerCommunications
                          employerIdentityId={data.employer.identity.id}
                          communicationType='WhatsApp'
                          urlPath={currentPath}
                          title={null}
                          lockOnCommunicationType={true}
                        />
                      </ErrorBoundary>
                    )
                  }}
                </Query>
            }
          </div>
        </React.Fragment>
      )
    }

    if (currentTab === EDITOR) {
      return (
        <div className='slds-size_1-of-1 slds-p-around_large'>
          {isEmployerGroupAccount
            ? <div className='slds-p-around_medium' style={{ textAlign: 'center' }}>
                <SvgIcon
                  variant='utility'
                  symbol='info'
                  colour='light'
                  className='slds-m-right_small'
                />
                <span className='u-font-size-larger'>
                  Please log into the specific subsidiary account(s) to edit & view current WhatsApp menus
                </span>
                <div className='slds-m-top_large' style={{ textAlign: 'left' }}>
                  <EmployerAccountSwitcher
                    currentEmployerId={this.state.selectedAccountId}
                    buttonText='Log into selected account'
                    onSelectionClick={this.changeSelectedAccountId}
                    onClick={() => switchAccount(this.state.selectedAccountId)}
                    buttonDisabled={this.state.selectedAccountId === this.props.match.params.employerGroupId}
                    className='slds-grid'
                    style={{ flexDirection: 'column', alignItems: 'center' }}
                    optionsClassName='u-font-size-larger'
                    showGroupAccountAsOption={false}
                  />
                </div>
              </div>
            : <EmployerWhatsAppEditor
                employerId={this.props.match.params.employerId}
              />
          }
        </div>
      )
    }
  }

  render() {
    let tabs = ['Messages', 'Editor']

    return (
      <div className='slds-grow slds-scrollable_y' role="main">
        <div className='slds-grid slds-wrap slds-size_1-of-1'>
          <div className='tab-nav slds-size_1-of-1 u-bg-color-white product-listing-page-header'>
            {this.props.title !== null &&
              <div className='slds-m-top_x-small slds-m-bottom_x-small slds-p-left_large product-listing-page-header_title'>
                {this.props.title}
              </div>
            }
            {this.props.noStatusFilter
              ? null
              : <TabbedView
                  tabs={tabs}
                  contents={[]}
                  selectedTab={this.state.currentTab}
                  onClick={tabIndex => this.setState({ currentTab: tabIndex }, this.setQueryString)}
                  tabsClassName='slds-align_absolute-center product-listing-page-header_tabs'
                />
            }
          </div>
          <AccountContext.Consumer>
            {({ isEmployerGroupAccount, switchAccount }) => (
              this.displayAssociatedContent(this.state.currentTab, isEmployerGroupAccount, switchAccount)
            )}
          </AccountContext.Consumer>
        </div>
      </div>
    )
  }
}

export default withRouter(EmployerWhatsApp)



// WEBPACK FOOTER //
// ./src/containers/messageplus/EmployerWhatsApp.js